import { CommonAccountDetails, CommonAccountState } from '@provider-portal/common/services/types';
import jwtDecode from 'jwt-decode';
import { createSelector } from 'reselect';

import { GlobalAppState } from 'rdx/state';
import { ErrorReporter } from '@provider-portal/common/utils/errorReporting';

// Keeps `details` referentially stable, so AccountService doesn't emit on unrelated store updates
const selectAccountDetails = createSelector(
  (globalState: GlobalAppState) => globalState.account?.details,
  (details): CommonAccountDetails | undefined =>
    details
      ? {
          account_data: details.account_info.account_data,
          assignments: details.account_info.assignments,
          assignedProvidersByVendor: details.account_info.assignedProvidersByVendor,
        }
      : undefined,
);

export function commonAccountAdapter(globalState: GlobalAppState): CommonAccountState {
  const accountDetails = selectAccountDetails(globalState);

  let vendorPermissions;
  const { accessToken } = globalState.session;
  if (accessToken) {
    try {
      const accountInfo = jwtDecode(accessToken) as
        | undefined
        | { data?: { vendor_permissions: { vendor_id: number }[] } };
      vendorPermissions = accountInfo?.data?.vendor_permissions.map(
        (vendorPermission) => vendorPermission.vendor_id,
      );
    } catch (e) {
      ErrorReporter.captureException(e);
    }
  }

  return {
    details: accountDetails,
    requestState: globalState.account?.requestState,
    selectedProvider: globalState.account?.selectedProvider,
    selectedVendor: globalState.account?.selectedVendor,
    vendorPermissions,
  };
}
